<template>
	<BaseCenteredMessage hideActions hideHelpButton hideLogoutButton>
		<template #title>Account deletion successful</template>
		<template #details>
			The account has been deleted and you will be logged out in a few seconds. We also sent you an email to
			confirm that your account deletion is complete.
			<br /><br />You may close this tab.
		</template>
	</BaseCenteredMessage>
</template>

<script>
import {useTitle} from 'shared/composables/useTitle'

export default {
	name: 'AccountDeleted',
	setup() {
		useTitle('Account deletion successful')
	},
	mounted() {
		if (!this.$auth.isAuthenticated.value) return
		setTimeout(() => this.$auth.logout({logoutOfAllTargets: true}), 5000)
	},
}
</script>
